import { stringLiteral } from '@execonline-inc/decoders';
import { identity } from '@kofno/piper';
import { Decoder, field, maybe, number, oneOf, string, succeed } from 'jsonous';
import {
  EndOfStream,
  StreamBase,
  StreamError,
  StreamedChatMessage,
  StreamedChunk,
  StreamedFullText,
} from './Types';

export type StreamedMessageType = 'chunk' | 'full-text' | 'end-of-stream';

export interface MessagesSuccess {
  status: string;
}

const streamBaseDecoder: Decoder<StreamBase> = succeed({})
  .assign('turnUUID', field('turn_uuid', string))
  .assign('seq', maybe(field('seq', number)))
  .map<StreamBase>(identity);

const streamedChunkDecoder: Decoder<StreamedChunk> = streamBaseDecoder
  .assign('type', field('type', stringLiteral('chunk')))
  .assign('content', field('content', string));

const streamedFullTextDecoder: Decoder<StreamedFullText> = streamBaseDecoder
  .assign('type', field('type', stringLiteral('full-text')))
  .assign('content', field('content', string));

const endOfStreamDecoder: Decoder<EndOfStream> = streamBaseDecoder.assign(
  'type',
  field('type', stringLiteral('end-of-stream')),
);

const streamErrorDecoder: Decoder<StreamError> = streamBaseDecoder
  .assign('type', field('type', stringLiteral('stream-error')))
  .assign('message', field('message', string));

export const streamedChatMessageDecoder: Decoder<StreamedChatMessage> = oneOf<StreamedChatMessage>([
  streamedChunkDecoder.map<StreamedChatMessage>(identity),
  streamedFullTextDecoder.map<StreamedChatMessage>(identity),
  endOfStreamDecoder.map<StreamedChatMessage>(identity),
  streamErrorDecoder.map<StreamedChatMessage>(identity),
]);

export const messagesDecoder: Decoder<MessagesSuccess> = succeed({}).assign(
  'status',
  field('status', string),
);
